import { useStateValue } from "../context/state/provider";
import { auth, db } from "../services/firebase/firebase";
import { VIEW } from "../constants/view.constants";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Box from '@mui/material/Box'; // For wrapping and applying sx prop styles
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../helpers/authConfig';

//base URL for SQL query
let baseURLsso = "";

if (process.env.REACT_APP_PROJECT_ID === "sail-dev-62f69") {
	//DEV
	// baseURLsso = "https://sail-dev-open.firebaseapp.com/";
	baseURLsso = "https://dev-agent.sail.cx/?view=full";
} else if (process.env.REACT_APP_PROJECT_ID === "sail-staging-4dcfb") {
	//STAGE
	// baseURLsso = "https://sail-staging-open.firebaseapp.com/";
	baseURLsso = "https://staging-agent.sail.cx/?view=full";
} else if (process.env.REACT_APP_PROJECT_ID === "eco-seeker-310618") {
	//PRODUCTION
	// baseURLsso = "https://sail-live-open.firebaseapp.com/";
	baseURLsso = "https://agent.sail.cx/?view=full";
}
console.log("baseURLsso", baseURLsso);

export default function UserModal({ onClose, open, firestore, setLoggingOut, userDB, chatbotId }) {
	const { instance, accounts } = useMsal();
	const [{ user, view }, dispatch] = useStateValue();

	const handleClose = () => {
		onClose();
	};

	const handleLogoutButton = async () => {
		//First check if the user is logged in using Microsoft
		//Set logginOut state to hide input field and error message
		//if any while the logout and fetch of new greeting message is completed
		dispatch({
			type: "LOGGING_OUT",
			loggingOut: true,
		});

		// Auth change triggers firestore room setter in app.js useEffect
		// This generates a New Room/Random ID
		const loggedInUid = auth.currentUser.uid;
		const tmpRoomId = loggedInUid + "***" + chatbotId
		// console.log("tmpRoomId", tmpRoomId);
		// console.log("chatbotId", chatbotId);
		// console.log("chatbotId", JSON.parse(sessionStorage.getItem("CLIENT")).chatbotId);
		// console.log("-------------STET CHATBOT-----------")

		await firestore
			.collection("rooms")
			.doc(tmpRoomId)
			.set({
				pendingMessages: 0,
				chatbotId: chatbotId,
				prevProvider: "",
				prevProviderId: "",
				liveAgent: "Complete",
				liveAgentLevel: 0,
				userLevel: 0
			}, { merge: true })
			.then(() => {
				// Update user status to false before signing out
				const userId = loggedInUid;
				const clientId = chatbotId;
				const userRef = db.ref(`rooms/${userId}/clientIds/${clientId}`);
				userRef.set(false).catch(error => {
					console.error('Error updating user status in db:', error);
				});
				auth.signOut()
					.then(async () => {
						console.log("Signout Successful");

						dispatch({
							type: "ADMIN_SETTINGS",
							admin: {
								adminUser: false,
								feedbackOn: false,
							},
						});
						localStorage.removeItem("userType");

						//MS logout
						if (instance.getAllAccounts().length > 0) {
							const response = await instance.acquireTokenSilent({
								...loginRequest,
								account: accounts[0],
							});
							// console.log("MS logout response", response);
							// console.log('MS logout response clientId:', clientId);

							//If login in Microsoft log out from Miscrosoft first and the from Firebase
							if (response.account.username) {
								//user is logged in using MS then logout
								await instance.logoutPopup({
									postLogoutRedirectUri: "/",
									mainWindowRedirectUri:`${baseURLsso}&id=${clientId}`,

									//DEV
									// mainWindowRedirectUri: "https://sail-dev-62f69.firebaseapp.com/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696"
									// mainWindowRedirectUri: "https://sail-dev-open.firebaseapp.com/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696"
									// mainWindowRedirectUri: "http://localhost:3000/?id=494cd860-7d72-4e9c-8dc3-77e98a04e696"
									// mainWindowRedirectUri: `http://localhost:3000/?id=${clientId}`
									//PRODUCTION
									// mainWindowRedirectUri: "https://agent.sail.cx/?view=full&id=08ac1804-f0d3-4b63-a15d-db08a3981782"

								});
							}
						}

						//Before closing the modal login as anonymous user
						auth.signInAnonymously()
							.then((currentUser) => {
								const tmpRoomId = currentUser.user.uid + "***" + chatbotId
								console.log("tmpRoomId", tmpRoomId);
								console.log("chatbotId", chatbotId);
								const snapShot = async () => {
									await firestore
										.collection("rooms")
										.doc(tmpRoomId)
										.get()
								}

								if (!snapShot.exists) {
									firestore
										.collection("rooms")
										.doc(tmpRoomId)
										.set({
											chatbotId: chatbotId,
										}, { merge: true })
								}
								//check userType in local storage
								localStorage.removeItem("userType");

								dispatch({
									type: "USER",
									user: {
										...user,
										id: currentUser.user.uid,
										loggedIn: false,
										name: null,
									},
								});

								dispatch({
									type: "SET_VIEW",
									view: VIEW.CHATROOM,
								});
								onClose(); //close modal
							})
							.catch((err) => {
								console.log("ERROR", err);
							});
					})
					.catch((err) => {
						console.error("signout error: ", err);
					});
			})
			.catch((err) => {
				console.error("signout error: ", err);
			});
	};

	const handleLoginButton = () => {
		dispatch({
			type: "SET_VIEW",
			view: VIEW.LOGIN,
		});
		onClose();
	};

	return (
		<Dialog
			aria-labelledby="simple-dialog-title"
			open={open}
			onClose={() => handleClose()}
			sx={{
				'& .MuiDialog-paper': {
					position: 'absolute',
					top: '90px',
					right: '20px',
					width: '120px',
					height: '32px',
					borderRadius: '10px',
					boxShadow: '0px 3px 25px rgba(0, 0, 0, 0.19)',
					padding: '8px',
					margin: '0',
					overflow: 'hidden',
					display: 'flex',
					justifyContent: 'center',
				}
			}}
		>
			<Box sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'start',
				'.userSettings': {
					color: 'black',
					border: 'none',
					backgroundColor: 'transparent',
					height: '12px',
					margin: '5px auto 5px 0',
					padding: '10px',
					'&:hover': {
						opacity: '0.8',
					},
					'&:focus': {
						outlineStyle: 'solid',
						outlineColor: 'var(--active-brand-color)',
						outlineWidth: '2px',
						boxShadow: 'none',
					},
				},
				'.icon': {
					marginRight: '12px',
					height: '18px',
					width: '18px',
				},
				'.disabledIcon': {
					opacity: '0.4',
				},
			}}>
				{userDB && !userDB.isAnonymous ? (
					<Button
						id="open-login"
						onClick={() => handleLogoutButton()}
						sx={{
							color: 'black',
							backgroundColor: 'transparent',
							textTransform: 'none',
							fontSize: '16px',
							fontFamily: 'averta std',
							'&:hover': {
								backgroundColor: 'transparent',
								opacity: '0.8',
							},
							'& .MuiButton-startIcon': {
								margin: 0,
								'& .icon': {
									fill: 'var(--active-brand-color, #000)', // Fallback if CSS variable isn't set
								},
							},
						}}
						startIcon={
							<svg
								className="icon"
								aria-hidden="true"
								width="18"
								height="18"
								viewBox="0 0 14 17"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M0 8.5C0 8.72543 0.0921874 8.94164 0.256282 9.10104C0.420376 9.26045 0.642936 9.35 0.875 9.35H7.51625L5.50375 11.2965C5.42174 11.3755 5.35664 11.4695 5.31222 11.5731C5.2678 11.6767 5.24493 11.7878 5.24493 11.9C5.24493 12.0122 5.2678 12.1233 5.31222 12.2269C5.35664 12.3305 5.42174 12.4245 5.50375 12.5035C5.58509 12.5832 5.68187 12.6464 5.7885 12.6896C5.89512 12.7327 6.00949 12.7549 6.125 12.7549C6.24051 12.7549 6.35488 12.7327 6.4615 12.6896C6.56813 12.6464 6.66491 12.5832 6.74625 12.5035L10.2463 9.1035C10.3259 9.02266 10.3884 8.92734 10.43 8.823C10.5175 8.61606 10.5175 8.38394 10.43 8.177C10.3884 8.07266 10.3259 7.97734 10.2463 7.8965L6.74625 4.4965C6.66467 4.41725 6.56781 4.35438 6.46122 4.31149C6.35462 4.2686 6.24038 4.24652 6.125 4.24652C6.00962 4.24652 5.89538 4.2686 5.78878 4.31149C5.68219 4.35438 5.58533 4.41725 5.50375 4.4965C5.42217 4.57575 5.35745 4.66984 5.3133 4.77339C5.26914 4.87694 5.24642 4.98792 5.24642 5.1C5.24642 5.21208 5.26914 5.32306 5.3133 5.42661C5.35745 5.53016 5.42217 5.62425 5.50375 5.7035L7.51625 7.65H0.875C0.642936 7.65 0.420376 7.73955 0.256282 7.89896C0.0921874 8.05837 0 8.27457 0 8.5ZM11.375 0H2.625C1.92881 0 1.26113 0.26866 0.768845 0.746878C0.276562 1.2251 0 1.8737 0 2.55V5.1C0 5.32543 0.0921874 5.54164 0.256282 5.70104C0.420376 5.86045 0.642936 5.95 0.875 5.95C1.10706 5.95 1.32962 5.86045 1.49372 5.70104C1.65781 5.54164 1.75 5.32543 1.75 5.1V2.55C1.75 2.32457 1.84219 2.10837 2.00628 1.94896C2.17038 1.78955 2.39294 1.7 2.625 1.7H11.375C11.6071 1.7 11.8296 1.78955 11.9937 1.94896C12.1578 2.10837 12.25 2.32457 12.25 2.55V14.45C12.25 14.6754 12.1578 14.8916 11.9937 15.051C11.8296 15.2104 11.6071 15.3 11.375 15.3H2.625C2.39294 15.3 2.17038 15.2104 2.00628 15.051C1.84219 14.8916 1.75 14.6754 1.75 14.45V11.9C1.75 11.6746 1.65781 11.4584 1.49372 11.299C1.32962 11.1396 1.10706 11.05 0.875 11.05C0.642936 11.05 0.420376 11.1396 0.256282 11.299C0.0921874 11.4584 0 11.6746 0 11.9V14.45C0 15.1263 0.276562 15.7749 0.768845 16.2531C1.26113 16.7313 1.92881 17 2.625 17H11.375C12.0712 17 12.7389 16.7313 13.2312 16.2531C13.7234 15.7749 14 15.1263 14 14.45V2.55C14 1.8737 13.7234 1.2251 13.2312 0.746878C12.7389 0.26866 12.0712 0 11.375 0Z"
									fill="var(--active-brand-color)"
								/>
							</svg>
						}
					>
						Logout
					</Button>
				) : (
					<Button
						id="open-login"
						onClick={() => handleLoginButton()}
						disabled={view === VIEW.LOGIN}
						sx={{
							color: 'black',
							backgroundColor: 'transparent',
							textTransform: 'none',
							fontSize: '16px',
							fontFamily: 'averta std',
							'&:hover': {
								backgroundColor: 'transparent',
								opacity: '0.8',
							},
							'& .MuiButton-startIcon': {
								margin: 0,
								'& .icon': {
									fill: 'var(--active-brand-color, #000)', // Use CSS variable for color
								},
							},
						}}
						startIcon={
							<svg
								className="icon"
								aria-hidden="true"
								width="18"
								height="18"
								viewBox="0 0 14 17"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M0 8.5C0 8.72543 0.0921874 8.94164 0.256282 9.10104C0.420376 9.26045 0.642936 9.35 0.875 9.35H7.51625L5.50375 11.2965C5.42174 11.3755 5.35664 11.4695 5.31222 11.5731C5.2678 11.6767 5.24493 11.7878 5.24493 11.9C5.24493 12.0122 5.2678 12.1233 5.31222 12.2269C5.35664 12.3305 5.42174 12.4245 5.50375 12.5035C5.58509 12.5832 5.68187 12.6464 5.7885 12.6896C5.89512 12.7327 6.00949 12.7549 6.125 12.7549C6.24051 12.7549 6.35488 12.7327 6.4615 12.6896C6.56813 12.6464 6.66491 12.5832 6.74625 12.5035L10.2463 9.1035C10.3259 9.02266 10.3884 8.92734 10.43 8.823C10.5175 8.61606 10.5175 8.38394 10.43 8.177C10.3884 8.07266 10.3259 7.97734 10.2463 7.8965L6.74625 4.4965C6.66467 4.41725 6.56781 4.35438 6.46122 4.31149C6.35462 4.2686 6.24038 4.24652 6.125 4.24652C6.00962 4.24652 5.89538 4.2686 5.78878 4.31149C5.68219 4.35438 5.58533 4.41725 5.50375 4.4965C5.42217 4.57575 5.35745 4.66984 5.3133 4.77339C5.26914 4.87694 5.24642 4.98792 5.24642 5.1C5.24642 5.21208 5.26914 5.32306 5.3133 5.42661C5.35745 5.53016 5.42217 5.62425 5.50375 5.7035L7.51625 7.65H0.875C0.642936 7.65 0.420376 7.73955 0.256282 7.89896C0.0921874 8.05837 0 8.27457 0 8.5ZM11.375 0H2.625C1.92881 0 1.26113 0.26866 0.768845 0.746878C0.276562 1.2251 0 1.8737 0 2.55V5.1C0 5.32543 0.0921874 5.54164 0.256282 5.70104C0.420376 5.86045 0.642936 5.95 0.875 5.95C1.10706 5.95 1.32962 5.86045 1.49372 5.70104C1.65781 5.54164 1.75 5.32543 1.75 5.1V2.55C1.75 2.32457 1.84219 2.10837 2.00628 1.94896C2.17038 1.78955 2.39294 1.7 2.625 1.7H11.375C11.6071 1.7 11.8296 1.78955 11.9937 1.94896C12.1578 2.10837 12.25 2.32457 12.25 2.55V14.45C12.25 14.6754 12.1578 14.8916 11.9937 15.051C11.8296 15.2104 11.6071 15.3 11.375 15.3H2.625C2.39294 15.3 2.17038 15.2104 2.00628 15.051C1.84219 14.8916 1.75 14.6754 1.75 14.45V11.9C1.75 11.6746 1.65781 11.4584 1.49372 11.299C1.32962 11.1396 1.10706 11.05 0.875 11.05C0.642936 11.05 0.420376 11.1396 0.256282 11.299C0.0921874 11.4584 0 11.6746 0 11.9V14.45C0 15.1263 0.276562 15.7749 0.768845 16.2531C1.26113 16.7313 1.92881 17 2.625 17H11.375C12.0712 17 12.7389 16.7313 13.2312 16.2531C13.7234 15.7749 14 15.1263 14 14.45V2.55C14 1.8737 13.7234 1.2251 13.2312 0.746878C12.7389 0.26866 12.0712 0 11.375 0Z"
									fill="var(--active-brand-color)"
								/>
							</svg>
						}
					>
						Login
					</Button>
				)}
			</Box>
		</Dialog>
	);
}
